import { render, staticRenderFns } from "./ReserveCancelCollectionsTable.vue?vue&type=template&id=57912e91&"
import script from "./ReserveCancelCollectionsTable.vue?vue&type=script&lang=ts&"
export * from "./ReserveCancelCollectionsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
